import Title from "@components/Title";
import cn from "classnames";
import ContentHeader from "@components/ContentHeader";
import { FC, memo } from "react";

const CorrelationHeader: FC = () => {
	return (
		<ContentHeader
			className="CorrelationHeader"
			testId="blockCorrelationHeader"
		>
			<Title
				className={cn("appears-right",)}
				testId="textCorrelationHeaderTitle"
			>
				CORRELATE
			</Title>
		</ContentHeader>
	)
}

export default memo(CorrelationHeader);